import { PouchDB } from '@dw/pouchdb-esm/pouchdb-find.js';

export default class LocalDbSyncManager {
  constructor(dbName) {
    this._dbName = dbName;
    this._syncStatusPromise = undefined;
    this._pouchdb = new PouchDB(dbName);
  }

  async _fetchSyncedStatus() {
    try {
      let doc = await this._pouchdb.get('_local/synced-with-server');
      this._status = doc.synced;
      return this._status;
    } catch (err) {
      if(err.status === 404) {
        return false;
      }
    }
  }

  /**
   * It returns true if the given database is synced with the server, false otherwise.
   * @return {Promise} 
   */
  async isSynced () {
    if (this._status !== undefined) {
      return this._status;
    }

    if (this._syncStatusPromise) {
      return this._syncStatusPromise;
    }

    this._syncStatusPromise = this._fetchSyncedStatus();
    this._status = await this._syncStatusPromise;
    this._syncStatusPromise = undefined;
    return this._status;
  }
  
  async _sync () {
    const isSynced = await this._fetchSyncedStatus();

    if(isSynced) {
      return;
    }

    return await this._pouchdb.put({
      _id: '_local/synced-with-server',
      synced: true
    });
  }
  
  /**
   * It marks the given database as synced with the server.
   * It creates `_local/synced-with-server` document in the database with { synced: true }
   * @return {Promise} 
   */
  async sync () {
    if (this._status) {
      return;
    }

    if (this._syncPromise) {
      return this._syncPromise;
    }

    this._syncPromise = this._sync();
    await this._syncPromise;
    this._status = true;
    this._syncPromise = null;
    return this._status;
  }
}
